import get from 'lodash/get';

import { interventions } from '../../config/interventions';
import { caseLogicMsg } from '../validationMessages';

function validateInterventionNodes(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];

  // Actions
  const interventionActionNodes = nodeInfo.actionNodes.filter(node => node.data && node.data.action && node.data.action.type === 'INTERVENTION');
  interventionActionNodes.forEach(node => {
    const action = get(node, 'data.action');
    if (!action.id) {
      errors.push(caseLogicMsg('You need to select an intervention', node.id));
    }
  });

  // Behavior effects
  const behaviorChangeNodes = nodeInfo.effectNodes.filter(
    (node) => {
      const effectType = get(node, 'data.effect.type');
      return  effectType === 'ANIMATION_REPEAT' || effectType === 'ANIMATION_ONE_SHOT'
    }
  );

  let foundCaseLogicError = false;
  for (const availIntv of caseConf.availableInterventions || []) {
    const intv = interventions.find(intv => intv.key === availIntv.key);
    if (intv && intv.availableStances) {
      for (const node of behaviorChangeNodes) {
        const position = get(node, 'data.effect.position');
        if (!intv.availableStances.includes(position) && !foundCaseLogicError) {
          errors.push(
            caseLogicMsg('Position not compatible with selected interventions.', node.id, { treatment: intv.treatment})
          );
          foundCaseLogicError = true;
        }
      }
    }
  }

  return {
    errors,
    warnings,
  };
}

export default validateInterventionNodes;